class ShamCountdown extends HTMLElement {
  connectedCallback() {
    this.endTime = new Date(this.dataset.end).getTime();
    this.expiredText = this.dataset.expiredText || '';
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();
    if (remaining <= 0) {
      clearInterval(this.interval);
      this.expire();
      return;
    }
    const d = Math.floor(remaining / 86400000);
    const h = Math.floor((remaining % 86400000) / 3600000);
    const m = Math.floor((remaining % 3600000) / 60000);
    const s = Math.floor((remaining % 60000) / 1000);
    this.innerHTML = this.format(d, h, m, s);
  }

  expire() {
    const link = this.dataset.expiredLink;
    const node = link
      ? Object.assign(document.createElement('a'), {
          href: link,
          className: 'sham-announcement-bar__link',
          textContent: this.expiredText,
        })
      : document.createTextNode(this.expiredText);

    const item = this.closest('.sham-announcement-bar__item');
    if (item) {
      const separator = item.querySelector('.sham-announcement-bar__separator');
      item.textContent = '';
      item.appendChild(node);
      if (separator) item.appendChild(separator);
    } else {
      this.textContent = '';
      this.appendChild(node);
    }
  }

  format(d, h, m, s) {
    const pad = n => String(n).padStart(2, '0');
    const unit = (val, label) =>
      `<span class="sham-countdown__unit">${val}<abbr class="sham-countdown__label">${label}</abbr></span>`;
    const parts = [];
    if (d > 0) parts.push(unit(d, 'd'));
    if (d > 0 || h > 0) parts.push(unit(d > 0 ? pad(h) : h, 'h'));
    if (d > 0 || h > 0 || m > 0) parts.push(unit(d > 0 || h > 0 ? pad(m) : m, 'm'));
    parts.push(unit(d > 0 || h > 0 || m > 0 ? pad(s) : s, 's'));
    return `<span class="sham-countdown__segments">${parts.join('')}</span>`;
  }
}

if (!customElements.get('sham-countdown')) {
  customElements.define('sham-countdown', ShamCountdown);
}
